import { c as l } from "../../../../index.esm-BeDSGXP5.js";
import { css as o } from "styled-components";
const s = {
  wrapper: ({ theme: e }) => /* @__PURE__ */ o([
    "margin-top:",
    ";"
  ], e.space.xs),
  base: () => /* @__PURE__ */ o([
    "",
    ""
  ], l({
    fontSize: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ],
    fontWeight: "regular",
    lineHeight: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ],
    display: "block"
  })),
  default: ({ theme: e }) => /* @__PURE__ */ o([
    "",
    ""
  ], l({
    color: e.componentColors.helperText.default
  })),
  success: ({ theme: e }) => /* @__PURE__ */ o([
    "",
    ""
  ], l({
    color: e.componentColors.helperText.success
  })),
  error: ({ theme: e }) => /* @__PURE__ */ o([
    "",
    ""
  ], l({
    color: e.componentColors.helperText.error
  })),
  alert: ({ theme: e }) => /* @__PURE__ */ o([
    "",
    ""
  ], l({
    color: e.componentColors.helperText.alert
  }))
};
export {
  s as default
};
